import * as types from '../config/actionTypes';

const PluginActions = {
    isBilling: (data) => {
        return { type: types.PLUGIN_BILLING_POP_UP, payload: data }
    },
};

export const pluginData = {
    pluginData: (data) => {
        return { type: types.PLUGIN_NAME, payload: data }
    },
};

export const ActivatedPluginData = {
    activatedPlugin: (data) => {
        return { type: types.ACTIVATED_PLUGIN_DATA, payload: data }
    },
};

export default PluginActions;